"use client";

import { Box, Grid, TextField, Typography } from "@mui/material";
import { pxToVw } from "@/utils/pxToVw";
import { MOBILE_BASE } from "@/theme/theme";
import { useState } from "react";
import { useText } from "@/context/TextContext";
import NewsletterDrawerSection from "./NewsletterDrawerSection";

export default function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  return (
    <Box>
      <Typography variant="body1" color="marron">
        {useText("block.newsletter.description")}
      </Typography>
      <Grid container>
        <Typography variant="body1" color="warmaa">
          {useText("block.newsletter.input")}
        </Typography>
        <Box
          display={{ xs: "none", md: "inline-block" }}
          ml={pxToVw(10)}
          flexGrow={1}
          position={"relative"}
          mt={pxToVw(3)}
        >
          <TextField
            id="newsletter-email-desktop"
            type="email"
            name="newsletter-email-desktop"
            fullWidth
            variant="standard"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            slotProps={{
              input: {
                disableUnderline: true,
                style: {
                  color: "#858276",
                  fontSize: pxToVw(48),
                  height: pxToVw(48),
                },
              },
            }}
          />
          <Box
            position={"absolute"}
            width={"100%"}
            bgcolor={"#858276"}
            height={2}
            bottom={pxToVw(6)}
          ></Box>
        </Box>
        <Box
          display={{ xs: "inline-block", md: "none" }}
          ml={pxToVw(5, MOBILE_BASE)}
          flexGrow={1}
          position={"relative"}
          mt={pxToVw(2, MOBILE_BASE)}
        >
          <TextField
            id="newsletter-email-responsive"
            name="newsletter-email-responsive"
            type="email"
            fullWidth
            variant="standard"
            size="small"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            slotProps={{
              input: {
                disableUnderline: true,
                style: {
                  color: "#858276",
                  fontSize: pxToVw(22, MOBILE_BASE),
                  height: pxToVw(22, MOBILE_BASE),
                },
              },
            }}
          />
          <Box
            position={"absolute"}
            width={"100%"}
            bgcolor={"#858276"}
            height={2}
            bottom={pxToVw(3, MOBILE_BASE)}
          ></Box>
        </Box>
      </Grid>
      <Typography
        variant="body1"
        color={email ? "marron" : "warmaa"}
        sx={{ cursor: email ? "pointer" : "default", display: "inline-block" }}
        onClick={() => email && setDrawerOpen(true)}
        id="button-newsletter-module"
      >
        (→)
      </Typography>
      <NewsletterDrawerSection
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        presetEmail={email}
      />
    </Box>
  );
}
